export * from './interfaces';
export * from './tooltip.module';
export * from './tooltip.service';
export {EventService as TooltipEventService} from './overlay/event.service';